"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NinjaAction = void 0;

var _lit = require("lit");

var _decorators = require("lit/decorators.js");

var _classMap = require("lit/directives/class-map.js");

var _unsafeHtml = require("lit/directives/unsafe-html.js");

var _join = require("lit/directives/join.js");

require("@material/mwc-icon");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __decorate = void 0 && (void 0).__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var NinjaAction = /*#__PURE__*/function (_LitElement) {
  _inherits(NinjaAction, _LitElement);

  var _super = _createSuper(NinjaAction);

  function NinjaAction() {
    var _this;

    _classCallCheck(this, NinjaAction);

    _this = _super.call(this);
    _this.selected = false;
    /**
     * Display hotkey as separate buttons on UI or as is
     */

    _this.hotKeysJoinedView = true;

    _this.addEventListener('click', _this.click);

    return _this;
  }
  /**
   * Scroll to show element
   */


  _createClass(NinjaAction, [{
    key: "ensureInView",
    value: function ensureInView() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.scrollIntoView({
          block: 'nearest'
        });
      });
    }
  }, {
    key: "click",
    value: function click() {
      this.dispatchEvent(new CustomEvent('actionsSelected', {
        detail: this.action,
        bubbles: true,
        composed: true
      }));
    }
  }, {
    key: "updated",
    value: function updated(changedProperties) {
      if (changedProperties.has('selected')) {
        if (this.selected) {
          this.ensureInView();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var icon;

      if (this.action.mdIcon) {
        icon = (0, _lit.html)(_templateObject || (_templateObject = _taggedTemplateLiteral(["<mwc-icon part=\"ninja-icon\" class=\"ninja-icon\"\n        >", "</mwc-icon\n      >"])), this.action.mdIcon);
      } else if (this.action.icon) {
        icon = (0, _unsafeHtml.unsafeHTML)(this.action.icon || '');
      } // const hotkey = this.action.hotkey
      //   ? html`<div class="ninja-hotkey">${this.action.hotkey}</div>`
      //   : '';


      var hotkey;

      if (this.action.hotkey) {
        if (this.hotKeysJoinedView) {
          hotkey = this.action.hotkey.split(',').map(function (hotkeys) {
            var keys = hotkeys.split('+');
            var joinedKeys = (0, _lit.html)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), (0, _join.join)(keys.map(function (key) {
              return (0, _lit.html)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<kbd>", "</kbd>"])), key);
            }), '+'));
            return (0, _lit.html)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["<div class=\"ninja-hotkey ninja-hotkeys\">\n            ", "\n          </div>"])), joinedKeys);
          });
        } else {
          hotkey = this.action.hotkey.split(',').map(function (hotkeys) {
            var keys = hotkeys.split('+');
            var keyElements = keys.map(function (key) {
              return (0, _lit.html)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["<kbd class=\"ninja-hotkey\">", "</kbd>"])), key);
            });
            return (0, _lit.html)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["<kbd class=\"ninja-hotkeys\">", "</kbd>"])), keyElements);
          });
        }
      }

      var classes = {
        selected: this.selected,
        'ninja-action': true
      };
      return (0, _lit.html)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      <div\n        class=\"ninja-action\"\n        part=\"ninja-action ", "\"\n        class=", "\n      >\n        ", "\n        <div class=\"ninja-title\">", "</div>\n        ", "\n      </div>\n    "])), this.selected ? 'ninja-selected' : '', (0, _classMap.classMap)(classes), icon, this.action.title, hotkey);
    }
  }]);

  return NinjaAction;
}(_lit.LitElement);

exports.NinjaAction = NinjaAction;
NinjaAction.styles = (0, _lit.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    :host {\n      display: flex;\n      width: 100%;\n    }\n    .ninja-action {\n      padding: 0.75em 1em;\n      display: flex;\n      border-left: 2px solid transparent;\n      align-items: center;\n      justify-content: start;\n      outline: none;\n      transition: color 0s ease 0s;\n      width: 100%;\n    }\n    .ninja-action.selected {\n      cursor: pointer;\n      color: var(--ninja-selected-text-color);\n      background-color: var(--ninja-selected-background);\n      border-left: 2px solid var(--ninja-accent-color);\n      outline: none;\n    }\n    .ninja-action.selected .ninja-icon {\n      color: var(--ninja-selected-text-color);\n    }\n    .ninja-icon {\n      font-size: var(--ninja-icon-size);\n      max-width: var(--ninja-icon-size);\n      max-height: var(--ninja-icon-size);\n      margin-right: 1em;\n      color: var(--ninja-icon-color);\n      margin-right: 1em;\n      position: relative;\n    }\n\n    .ninja-title {\n      flex-shrink: 0.01;\n      margin-right: 0.5em;\n      flex-grow: 1;\n      font-size: 0.8125em;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n    .ninja-hotkeys {\n      flex-shrink: 0;\n      width: min-content;\n      display: flex;\n    }\n\n    .ninja-hotkeys kbd {\n      font-family: inherit;\n    }\n    .ninja-hotkey {\n      background: var(--ninja-secondary-background-color);\n      padding: 0.06em 0.25em;\n      border-radius: var(--ninja-key-border-radius);\n      text-transform: capitalize;\n      color: var(--ninja-secondary-text-color);\n      font-size: 0.75em;\n      font-family: inherit;\n    }\n\n    .ninja-hotkey + .ninja-hotkey {\n      margin-left: 0.5em;\n    }\n    .ninja-hotkeys + .ninja-hotkeys {\n      margin-left: 1em;\n    }\n  "])));

__decorate([(0, _decorators.property)({
  type: Object
})], NinjaAction.prototype, "action", void 0);

__decorate([(0, _decorators.property)({
  type: Boolean
})], NinjaAction.prototype, "selected", void 0);

__decorate([(0, _decorators.property)({
  type: Boolean
})], NinjaAction.prototype, "hotKeysJoinedView", void 0);

exports.NinjaAction = NinjaAction = __decorate([(0, _decorators.customElement)('ninja-action')], NinjaAction);